import { createContext } from "react";

import { type Store, store } from "./store.js";

export const StoreContext = createContext<Store>(store);
